import { isNil } from "lodash-es";

import { PoolItemDto } from "@/core/api/generated/v1";

export class PoolItemHelper {
  public static canUpdate(poolItem: PoolItemDto | null | undefined): boolean {
    return isNil(poolItem?.usedByEntity);
  }

  public static canUpdateStatus(poolItem: PoolItemDto | null | undefined): boolean {
    return isNil(poolItem?.usedByEntity);
  }

  public static canDelete(poolItem: PoolItemDto | null | undefined): boolean {
    return isNil(poolItem?.usedByEntity);
  }
}
